import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import Star from '../Icons/Star';

const StarRating = ({ rating, readonly, updateRating }) => {
  const starElements = Array(5).fill(<></>);
  const [ratingValue, setRatingValue] = useState(rating);
  const [hoveredRating, setHoveredRating] = useState(null);

  const logRating = (newRating) => {
    if (readonly) return;
    setRatingValue(newRating);
    updateRating(newRating);
  };

  return (
    <div className="flex items-center gap-2">
      {starElements.map((element, index) => {
        return (
          <span key={`${element}-${index}`}>
            {!readonly && (
              <input
                type="radio"
                id={`star-${index}`}
                value={index + 1}
                name="rating"
                className="rating-input hidden"
                disabled={readonly}
                checked={rating === index + 1}
                onChange={() => {
                  logRating(index + 1);
                }}
              />
            )}
            <label
              htmlFor={!readonly && `star-${index}`}
              className="cursor-pointer"
              onMouseOver={() => {
                if (!readonly) {
                  setHoveredRating(index + 1);
                }
              }}
              onMouseLeave={() => {
                if (!readonly) {
                  setHoveredRating(null);
                }
              }}
            >
              <Star
                classNames="w-6 h-6"
                fileName="Rating"
                primaryFill={
                  index + 1 <= (hoveredRating || ratingValue)
                    ? '#1D4ED8'
                    : '#D9D9D9'
                }
                secondaryFill={
                  index + 1 === Math.floor(ratingValue) && ratingValue % 1 !== 0
                    ? '#1D4ED8'
                    : null
                }
              />
            </label>
          </span>
        );
      })}
    </div>
  );
};

export default StarRating;

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  readonly: PropTypes.bool,
  updateRating: PropTypes.func
};

StarRating.defaultProps = {
  readonly: false,
  updateRating: () => {}
};
